import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const GuestsOutline = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 11C7 9.34315 8.34315 8 10 8C11.6569 8 13 9.34315 13 11C13 12.6569 11.6569 14 10 14C8.34315 14 7 12.6569 7 11ZM10 6C7.23858 6 5 8.23858 5 11C5 13.7614 7.23858 16 10 16C12.7614 16 15 13.7614 15 11C15 8.23858 12.7614 6 10 6ZM10.3121 19C10.8087 18.9982 11.3038 19.0503 11.7877 19.1555C12.3273 19.2728 12.8599 18.9303 12.9772 18.3906C13.0945 17.851 12.752 17.3184 12.2123 17.2011C11.5871 17.0652 10.9481 16.9978 10.3075 17.0001C9.22229 16.998 8.14641 17.2011 7.14116 17.5986C6.13492 17.9965 5.21792 18.582 4.44387 19.3234C3.66974 20.0648 3.05374 20.9478 2.63346 21.9229C2.21313 22.898 1.99746 23.9447 2.00002 25.0024C2.00136 25.5547 2.45016 26.0013 3.00244 26C3.55473 25.9987 4.00136 25.5499 4.00002 24.9976C3.99812 24.2156 4.15747 23.4399 4.47011 22.7145C4.7828 21.9891 5.24327 21.3271 5.82729 20.7677C6.41141 20.2082 7.10749 19.7626 7.87662 19.4585C8.6458 19.1543 9.47154 18.9982 10.306 19.0001L10.3121 19ZM22 8C20.3431 8 19 9.34315 19 11C19 12.6569 20.3431 14 22 14C23.6569 14 25 12.6569 25 11C25 9.34315 23.6569 8 22 8ZM17 11C17 8.23858 19.2386 6 22 6C24.7614 6 27 8.23858 27 11C27 13.7614 24.7614 16 22 16C19.2386 16 17 13.7614 17 11ZM17.7574 20.7574C18.8826 19.6321 20.4087 19 22 19C23.5913 19 25.1174 19.6321 26.2426 20.7574C27.3679 21.8826 28 23.4087 28 25C28 25.5523 28.4477 26 29 26C29.5523 26 30 25.5523 30 25C30 22.8783 29.1571 20.8434 27.6569 19.3431C26.1566 17.8429 24.1217 17 22 17C19.8783 17 17.8434 17.8429 16.3431 19.3431C14.8429 20.8434 14 22.8783 14 25C14 25.5523 14.4477 26 15 26C15.5523 26 16 25.5523 16 25C16 23.4087 16.6321 21.8826 17.7574 20.7574Z"
        fill={color}
      />
    </svg>
  );
};

export default GuestsOutline;
